export default __webpack_public_path__ + "static/media/international-payment-systems.0b3c3de4.svg";